import * as React from "react";
import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import RedactedWrapper from "lib/core_components/RedactedWrapper";
import UIcon, { IconKey } from "lib/icons/untitled_ui/UIcon";
import { ProHelperDataTypes } from "lib/providers/ProHelper";
import { sysTextSecondary } from "lib/themes/colors";

type Props = {
  title: React.ReactNode;
  value: React.ReactNode;
  icon?: IconKey;
  // If a data type is required, the value will be redacted if the user
  // does not have access to that data type
  requiredDataType?: ProHelperDataTypes;
};

export default function Property({ title, value, icon, requiredDataType }: Props) {
  return (
    <Flex gap={8} alignItems="center">
      {icon && <UIcon icon={icon} size={12} color={sysTextSecondary} />}
      <PropertyWrapper isTitle>{title}</PropertyWrapper>
      <PropertyWrapper>
        <RedactedWrapper
          requiredDataType={requiredDataType}
          redactContent={value ? value : "--"}
          showModalOnClick={false}
        >
          {value ? value : <span aria-label="unknown-value">--</span>}
        </RedactedWrapper>
      </PropertyWrapper>
    </Flex>
  );
}

const PropertyWrapper = styled(Flex)<{ isTitle?: boolean }>(({ theme, isTitle }) => ({
  fontSize: "12px",
  color: isTitle ? theme.colors.sysTextSecondary : theme.colors.sysTextDefault,
  fontWeight: 500,
  minWidth: isTitle ? "120px" : 0,
}));
